<!--  -->
<template>
  <div class="myroad">
    <!-- <header>
       <span class="back" @click='back()'></span> 
      <span>我的路线</span>
       <span class="more"></span> 
    </header>-->
    <div class="content_myroad">
      <div class="img">
        <img src="../assets/images/images/wodexianlu-top-bg.png" alt="" />
      </div>
      <div class="box">

        <div class="item" v-for='(item,i) in roadlist' :key="i">

          <div class="detail">
            <h3 @click="myroad(item.id)"><span v-for='(list,j) in item.tourRoutes' :key='j'>{{list.name}}<i>———</i></span></h3>
            <p>主题类型:{{item.theme}}</p>
            <p>主题描述:{{item.description}}</p>
            <div class="bot">
              <dd class="time">预估{{item.tourDay}}天</dd>
              <dl>
                <dd class="vote1" @click="vote(item.id)" v-if='item.isVote==0'><span>{{item.voteNum}}</span></dd>
                <dd class="vote1 voted" v-else-if='item.isVote!=0'><span>{{item.voteNum}}</span></dd>
                <dd class="fare1" @click="share(item.tourRoutes[0].tourID)"><span>转发</span></dd>
              </dl>
            </div>

          </div>

        </div>
        <div class="gift" @click="gift()">
          <img src="../assets/images/icon_jp.png" width="32" alt="" />
          <span>1</span>
        </div>
        <el-pagination @current-change='currentchange' layout="prev, pager, next" :total="page.count">
        </el-pagination>
      </div>

    </div>

  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { API_1, Global } from "../conf/api";
import "../assets/css.css";
export default {
  //import引入的组件需要注入到对象中才能使用
  name: "myroad",
  components: {},
  data() {
    //这里存放数据
    return {
      token: "",
      userid: "",
      userimg: "",
      username: "",
      roadlist: [],
      voteSingleNum: 0,
      page: {
        currentPage: 0,
        count: 0,
        pageSize: 10,
      },
    };
  },
  async mounted() {
    let params = this.$route.query;
    this.token = params.token;
    await this.axios
      .get("https://www.ccmapp.cn/middleware/userextrainfo", {
        // .get("https://testapi.ccmapp.cn:15400/middleware/userextrainfo", {
        params: {
          token: this.token,
        },
      })
      .then((res) => {
        this.username = res.data.data.user.username;
        this.userimg = res.data.data.photo;
        this.userid = res.data.data.user._id;
      });
    this.listTour();
  },

  methods: {
    gift() {
      //window.location.href = "httthis.$routerp://172.10.103.61:9000?userId=" + this.userid;
      if (this.userid != "") {
        this.$router.push({
          name: "Home",
          query: {
            userId: this.userid,
            userName: this.username,
          },
        });
      }
    },
    myroad(id) {
      this.$router.push({
        path: "/roadmap",
        query: {
          token: this.token,
          uid: this.userid,
          tourid: id,
          currentPage: this.page.currentPage,
          mine: "mine",
        },
      });
    },
    vote(id) {
      if (this.voteSingleNum < 20) {
        this.axios
          .get(API_1 + Global.vote, {
            params: {
              id: id,
              userID: this.userid,
            },
          })
          .then((res) => {
            console.log(res, "vote");
            localStorage.setItem("voteSingleNum", this.voteSingleNum);
            this.listTour();
          });
      } else {
        this.$message("投票次数已用尽!");
      }
    },
    share(tid) {
      this.axios
        .get(API_1 + Global.share, {
          params: {
            userID: this.userid,
            tourID: tid,
          },
        })
        .then((res) => {
          console.log(res, "share");
          if (res.data.code == 200) {
            this.roadlist.map((item) => {
              if (item.id == tid) {
                console.log(item);
                let title = "";
                item.tourRoutes.map((i, index) => {
                  if (item.tourRoutes.length - 1 == index) {
                    title += i.name;
                  } else {
                    title += i.name + "-";
                  }
                });
                window.location.href =
                  "/myroad?option=share&shareDescription=" +
                  item.description +
                  "&shareImage=https://testapi.ccmapp.cn/apis/file/dl/source/5f7157b3c182cd5ca4ab5e22.png&shareTitle=" +
                  title +
                  "&shareUrl=https://apps.ccmapp.cn/dist/jump.html?tourid=" +
                  tid +
                  "&currentPage=" +
                  this.page.currentPage +
                  "$theme=" +
                  this.currtheme;
              }
            });
          }
        });
    },
    currentchange(val) {
      //分页
      console.log(val);
      this.page.currentPage = val;
      this.listTour();
    },
    listTour() {
      let params = {
        searchUserID: this.userid,
        searchTheme: "",
        searchMine: this.userid,
        pageSize: this.page.pageSize,
        currentPage: this.page.currentPage,
      };
      this.axios
        .get(API_1 + Global.listTour, {
          params: params,
        })
        .then((res) => {
          this.roadlist = res.data.data;
          this.page.count = res.data.count;
          console.log(res, this.roadlist);
        });
    },
    back() {
      this.$router.go(-1);
    },
  },
};
</script>

<style>
.box{ background:url(../assets/images/images/border-mid.png) scroll 0 20px repeat-y #fff; background-size: contain; margin: 15px 10px;
 position: relative; padding: 0 10px;}
.box:before{ position: absolute; display: block; content: ""; height: 14px; width: 100%; top: -14px; left: 0; background:url(../assets/images/images/border-top.png) top no-repeat #fff; background-size: 100% 14px; border-radius: 5px 5px 0 0;}
.box:after{ position: absolute; display: block; content: ""; height: 15px; width: 100%; bottom: -15px; left: 0; background:url(../assets/images/images/border-bottom.png) top no-repeat #fff; background-size: contain; border-radius: 0 0 5px 5px;}
.content_myroad {
  background: url(../assets/images/bg_myroad.png) left top no-repeat rgb(235,251,241);
  background-size: 100% auto;

  margin-bottom: 25px;
}
.content_myroad .box .item{ color: rgb(173,173,173); text-align: left; padding: 15px 15px; margin-bottom: 20ox; border-bottom: 1px solid rgb(239,252,243); }
.content_myroad .box .item .detail h3{ color: #333; font-size: 18px; line-height:24px;  margin-bottom: 20px;}
.content_myroad .box .item .detail h3 span{ font-weight: bold;}
.content_myroad .box .item .detail h3 span:last-child i{ display: none;}
.content_myroad .box .item .detail p{ font-size: 16px; margin-bottom: 10px; }
.content_myroad .box .item .detail .bot{ display: flex;}
.content_myroad .box .item .detail .bot .vote1{ padding-left: 25px; line-height: 25px;  flex: 1; background:url(../assets/images/images/zan-icon.svg) no-repeat; background-size: 22px; font-size: 16px;}
.content_myroad .box .item .detail .bot .fare1{ flex: 1; background:url(../assets/images/images/fenxiang-icon.svg) right no-repeat; background-size: 22px; font-size: 0;}
.content_myroad .box .item .detail .bot dd {  flex: 1; line-height: 25px; font-size: 16px;}
.content_myroad .box .item .detail .bot dl {  flex: 1; display: flex; line-height: 25px; font-size: 16px;}
.content_myroad > ul li {
  height: 210px;
  background: url(../assets/images/bg_box.png) no-repeat;
  background-size: 100% 100%;
  margin-bottom: 15px;
  padding: 43px 20px 0 20px;
  position: relative;
}

.content_myroad ul li .head {
  position: absolute;
  left: 20px;
  top: 43px;
  width: 20px;
}
.content_myroad .img{ margin-bottom: 25px;}
.content_myroad ul li .head img {
  border-radius: 50%;
}

.content_myroad ul li .detail {
  padding-left: 30px;
  text-align: left;
}

.content_myroad ul li .detail h3 {
  font-size: 14px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #0a65e7;
  line-height: 20px;
  margin-bottom: 8px;
  max-height: 60px;
  overflow: hidden;
}

.content_myroad ul li .detail p {
  font-size: 10px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #6798ff;
  line-height: 14px;
  margin-bottom: 8px;
}

.content_myroad ul li .detail > span {
  height: 16px;
  font-size: 12px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #fdac41;
  line-height: 16px;
}

.content_myroad ul li .detail .btn {
  margin-top: 12px;
  display: flex;
  justify-content: flex-end;
  position: absolute;
  right: 20px;
  bottom: 21px;
}

.gift {
  position: fixed;
  right: 10px;
  bottom: 20px;
  width: 50px;
  height: 50px;
  background: #f9eed9;
  border-radius: 50%;
  text-align: center;
  padding-top: 10px;
}
.gift img {
  width: 32px;
}
.gift span {
  width: 13px;
  height: 13px;
  border-radius: 50%;
  position: absolute;
  right: 5px;
  top: 5px;
  color: #fff;
  font-size: 10px;
  background: #ff5d5b;
}
</style>
